import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

/** Outlined button in neutral text and divider colors, for secondary toolbar triggers. */
export const SubtleOutlineButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.divider,
}));
